class EditPhoneController {
    /* @ngInject */

  constructor (UsersService, $mdDialog, $mdToast, username) {
    this.UsersService = UsersService
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.username = username
    this.updatedPhone = ''
  }

  submitUserInfoForApproval () {
    const data = {phone_number: this.updatedPhone}

    this.UsersService.submitUserContactInfoForApproval(data)
            .then(() => {
              this.$mdDialog.hide()
              this.$mdToast.show(
                    this.$mdToast.simple("Changes submitted. We'll verify them and update your account as soon as possible.")
                        .hideDelay(5000))
            })
            .catch((err) => {
              this.$mdToast.showSimple('Failed to submit changes')
            })
  }

  closeDialog () {
    this.$mdDialog.cancel()
  }
}

export default EditPhoneController
